import { apiRequest } from "@/shared/api/client";

export interface Statistic {
  movie_count?: number | null;
  tv_count?: number | null;
  episode_count?: number | null;
  movie_count_month?: number | null;
  tv_count_month?: number | null;
  episode_count_month?: number | null;
}

export interface DownloaderInfo {
  download_speed?: number | null;
  upload_speed?: number | null;
  download_size?: number | null;
  upload_size?: number | null;
  free_space?: number | null;
}

export interface DashboardSystemInfo {
  hostname: string;
  operating_system: string;
  runtime: number;
  version: string;
}

export function fetchStatistic() {
  return apiRequest<Statistic>("/api/v1/dashboard/statistic");
}

export function fetchDownloaderInfo() {
  return apiRequest<DownloaderInfo>("/api/v1/dashboard/downloader");
}

export function fetchSystemInfo() {
  return apiRequest<DashboardSystemInfo>("/api/v1/dashboard/system");
}

/** 近 N 天每日整理数量 */
export function fetchTransferStats(days = 7) {
  return apiRequest<number[]>(`/api/v1/dashboard/transfer?days=${days}`);
}
